import React, { useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { useWindowWidth } from "../../../hooks/useWindowWidth"
import { Container } from "../../Container/Container"
import { CartMenu } from "./Menu/CartMenu"
import { WishlistMenu } from "./Menu/WishlistMenu"
import { UserMenu } from "./Menu/UserMenu"
import { SearchForm } from "../LowerHeader/SearchForm/SearchForm"

import {
  HeadLogoLinkStyled,
  LowerHeaderStyled,
  MenuWrapper,
  SearchWrapper,
  SearchInputStyled,
} from "./LowerHeader.styled"

function useOutsideClick(ref, onOutside) {
  React.useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        onOutside()
      }
    }
    document.addEventListener("mousedown", handleClick)
    return () => document.removeEventListener("mousedown", handleClick)
  }, [ref, onOutside])
}

export const LowerHeader = () => {
  const width = useWindowWidth()
  const navigate = useNavigate()
  const [query, setQuery] = useState("")
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef(null)

  useOutsideClick(wrapperRef, () => setOpen(false))

  const handleInputFocus = () => {
    setOpen(true)
  }

  const handleNavigate = (to) => {
    navigate(to)
    setOpen(false)
    setQuery("")
  }

  return (
      <LowerHeaderStyled>
        <Container>
          {width > 767 && (
              <HeadLogoLinkStyled to="/">
                <img src="/logo_new.jpeg" className="rounded-full" style={{ borderRadius: '100%' }}
                      alt="Kupidai logo" loading="lazy" width="32" height="32"/>
                Kupidai
              </HeadLogoLinkStyled>
          )}

          <SearchWrapper ref={wrapperRef}>
            <SearchInputStyled
                value={query}
                placeholder="Ищите что-нибудь..."
                onChange={e => setQuery(e.target.value)}
                onFocus={handleInputFocus}
            />
            {open && (
                <SearchForm
                    query={query}
                    onChange={setQuery}
                    onNavigate={handleNavigate}
                />
            )}
          </SearchWrapper>

          <MenuWrapper>
            <CartMenu />
            <WishlistMenu />
            <UserMenu />
          </MenuWrapper>
        </Container>
      </LowerHeaderStyled>
  )
}
